import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, InputLabel, MenuItem,Select  } from "@mui/material";
import { Input } from "../../components/Input";
import style from "../../components/input.module.css";
const JobApplicationForm = ({ open, handleClose, jobTitle }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    education: "",
    resume: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    alert("Application Submitted Successfully!");
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Apply for {jobTitle}</DialogTitle>
      <DialogContent>
        <Input label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} className={style.input} />
        <Input label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} className={style.input} />
        <Input label="Email" type="email" name="email" value={formData.email} onChange={handleChange} className={style.input} />
        <Input label="Phone Number" type="tel" name="phone" value={formData.phone} onChange={handleChange} className={style.input} />
        
        <InputLabel style={{ marginTop: "10px" }}>Education</InputLabel>
        <Select fullWidth name="education" value={formData.education} onChange={handleChange}>
          <MenuItem value="High School">High School</MenuItem>
          <MenuItem value="Bachelor's">Bachelor's</MenuItem>
          <MenuItem value="Master's">Master's</MenuItem>
          <MenuItem value="PhD">PhD</MenuItem>
        </Select>
        
        <InputLabel style={{ marginTop: "10px" }}>Upload Resume</InputLabel>
        <input type="file" accept=".pdf,.doc,.docx" onChange={handleFileChange} className={style.input} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">Cancel</Button>
        <Button onClick={handleSubmit} color="primary">Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default JobApplicationForm;
